export enum ProcesoResultado {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS"
}

export interface MetaClub {
  idClub: number;
  club: string;
  metaVentas: number;
  metaReactivaciones: number;
  metaConsolidada: number;
  resultado: ProcesoResultado;
  mensaje: string;
}

export interface MetaRegional {
  numeroRegion: number;
  metaVentas: number;
  metaReactivaciones: number;
  metaConsolidada: number;
  clubes: MetaClub[];
  resultado: ProcesoResultado;
  mensaje: string;
}

export default interface MembresiaMetaCarga {
  metasRegionales: MetaRegional[];
  resultado: ProcesoResultado;
  mensaje: string;
  nombreArchivo?: string;
  fechaCarga?: string;
}
